<div class="alert-toast-stack" role="region" aria-label="Notifications" aria-live="polite">
  <lib-alert-snackbar
    *ngFor="let toast of (toasts$ | async) ?? []; trackBy: trackById"
    [data]="toast"
    (dismissed)="dismiss(toast.id)"
  ></lib-alert-snackbar>
</div>
